import { getAdminMemberBaseUrl } from '../BaseUrl';

// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface NotificationEndpointsProps {
  get_notification_list: (page: number, size: number) => string; // 알림 목록 조회
  get_notification_detail: (notificationId: string) => string; // 알림 상세 조회
  delete_notification: (notificationId: string) => string; // 알림 삭제
  get_unread_notification_count: () => string; // 읽지 않은 알림 개수 조회
}

// 사용자 알림 관련 엔드포인트 정의
export const NotificationEndpoints: NotificationEndpointsProps = {
  get_notification_list: (page, size) =>
    `${getAdminMemberBaseUrl()}/notifications?page=${page}&size=${size}`, // 알림 목록 조회
  get_notification_detail: (notificationId: string) =>
    `${getAdminMemberBaseUrl()}/notifications/${notificationId}`, // 알림 상세 조회
  delete_notification: (notificationId: string) =>
    `${getAdminMemberBaseUrl()}/notifications/${notificationId}`, // 알림 삭제
  get_unread_notification_count: () =>
    `${getAdminMemberBaseUrl()}/notifications/unread/cnt`, // 읽지 않은 알림 개수 조회
};

export default NotificationEndpoints;
